import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useJetpackConfigSelector } from "../../../../redux/jetpackConfig";
import {
  updateCustomerThunk,
  useAccountToDisplaySelector
} from "../../../../redux/actions/user";
import { FormikFormWrapperForJetpackConfig } from "../FormikForm/FormikFormWrapperForJetpackConfig";
import JetpackMarketingAutomationV2 from "./components/JetpackMarketingAutomationV2";
import KC_Text from "../../../../designsystem/typography/KC_Text/KC_Text";
import { KC_Text_Sizes, KC_Weights } from "../../../../designsystem/ds_commons";
import { tt } from "../../../../utils/i18n/i18n";
import MobileDashboardHeader from "../../../Layout/Mobile/MobileDashboardHeader";
import moment from "moment-timezone";
import KC_Heading2 from "../../../../designsystem/typography/KC-Heading/KC_Heading2";

export default function JetpackMarketingAutomationWrapper() {
  const jetpackConfig = useJetpackConfigSelector();
  const { accountToDisplay } = useAccountToDisplaySelector();
  const dispatch = useDispatch();
  const hasTrackedVisit = useRef(false);

  useEffect(() => {
    if (!accountToDisplay?.token) {
      return;
    }

    // Only run once per component mount
    if (hasTrackedVisit.current) {
      return;
    }

    const businessUser = accountToDisplay?.businessUser;
    const hasVisitedBefore = businessUser?.stepVisits?.marketingautomation;

    // If user hasn't visited this page before, track the visit
    if (
      !hasVisitedBefore &&
      accountToDisplay?.trackingID &&
      accountToDisplay?.token
    ) {
      hasTrackedVisit.current = true;

      dispatch(
        updateCustomerThunk(
          {
            stepVisits: {
              ...(businessUser?.stepVisits || {}),
              marketingautomation: moment().unix()
            }
          },
          accountToDisplay.trackingID,
          accountToDisplay.token
        ) as any
      );
    } else if (hasVisitedBefore) {
      // Already visited, mark as tracked to prevent future calls
      hasTrackedVisit.current = true;
    }
  }, [accountToDisplay]);

  if (jetpackConfig == null) {
    return <>{tt("error")}</>;
  }

  return (
    <div className="d-flex flex-column dashboard-v2">
      <MobileDashboardHeader
        title={tt("automated_emails")}
        description={tt("automated_emails_description")}
      />
      <div className="px-4 pt-5 w-100 d-none d-lg-flex">
        <div className="flex-grow-1">
          <KC_Heading2 text={tt("automated_emails")} />
          <KC_Text
            size={KC_Text_Sizes.lg}
            weight={KC_Weights.reg}
            text={tt("automated_emails_description")}
            className="text-secondary"
          />
        </div>
        <div className="d-flex gap-sm"></div>
      </div>

      <div className="flex-grow-1">
        <FormikFormWrapperForJetpackConfig
          ChildComponent={JetpackMarketingAutomationV2}
        />
      </div>
    </div>
  );
}
